import { memo } from "react";
import Info from "~icons/material-symbols/info-outline";
import { css } from "../../../../styled-system/css";
import { t } from "../../../libs/i18n";

export const InvitationEndedBanner = memo(() => {
  return (
    <section
      className={css({
        bg: "surface.accentPrimaryLight",
        rounded: "xl",
        p: "16px",
        display: "flex",
        flexDir: "column",
        gap: "12px",
      })}
    >
      <div
        className={css({
          display: "flex",
          gap: "4px",
          alignItems: "flex-start",
        })}
      >
        <Info
          className={css({
            color: "text.accentPrimary",
            width: "24px",
            height: "24px",
            flexShrink: 0,
          })}
        />
        <p
          className={css({
            fontSize: "16px",
            fontWeight: "400",
            lineHeight: "1.5",
            color: "text.primary",
          })}
        >
          {t("友だち紹介キャンペーンは終了しました")}
        </p>
      </div>

      <p
        className={css({
          color: "text.secondary",
          fontSize: "14px",
          lineHeight: "1.4",
          pl: "28px",
        })}
      >
        {t(
          "紹介件数が2万件に達したため、お友だち紹介キャンペーンは終了しました。",
        )}
      </p>
    </section>
  );
});
